import { useTranslation } from 'react-i18next'

export function BetaRibbon() {
  const { t } = useTranslation()

  return (
    <div
      aria-hidden="false"
      role="status"
      aria-label={t('common.beta', { defaultValue: 'Beta version' })}
      className="pointer-events-none fixed top-0 left-0 z-[600] h-[140px] w-[140px] overflow-hidden select-none max-md:h-[110px] max-md:w-[110px]"
    >
      <span
        className="bg-gradient-brand text-fg-inverse absolute top-[34px] -left-[52px] w-[200px] -rotate-45 py-1.5 text-center text-xs font-bold tracking-[0.2em] uppercase shadow-md max-md:top-[26px] max-md:-left-[58px] max-md:py-1 max-md:text-[10px]"
        style={{
          textShadow: '0 1px 0 rgba(255,255,255,0.25)',
        }}
      >
        {t('common.beta', { defaultValue: 'Beta' })}
      </span>
    </div>
  )
}
